/**
 ################################
 * Component geeg_hero_heading
 * Built with Maciste / Version 2.0
 ################################
 */

import 'jquery-parallax.js';
'use strict';
jQuery(document).ready(function ($) {
    $('.parallax-window').parallax({
        naturalWidth: 600,
        naturalHeight: 400,
    });

});